import { render } from "./BookList.vue?vue&type=template&id=58fdc4b5&scoped=true"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"

import "./BookList.vue?vue&type=style&index=0&id=58fdc4b5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fdc4b5"]])

export default __exports__